import VulcanSidebar from 'components/VulcanSidebar/VulcanSidebar';
import { Page } from 'crunch-components';
import { Outlet } from 'react-router-dom';

export default function PageWithSidebar() {
	return (
		<div className="flex min-h-screen">
			<VulcanSidebar />
			<Page>
				<Outlet />
			</Page>
		</div>
	);
}
